import styled from 'styled-components'
import {Tree, TreeItem, TreeItemContent, Button} from 'react-aria-components'
import {Checkbox} from '../checkbox/checkbox'
import {spacing} from '../../../theme/spacing'

const Styled = {
    Tree: styled(Tree)`
        &[data-disabled] {
            opacity: 0.5;
            pointer-events: none;
        }
    ` as typeof Tree,
    TreeItem: styled(TreeItem)`
        &[data-disabled] {
            opacity: 0.5;
        }
    `,
    TreeItemContent: styled(TreeItemContent)`` as typeof TreeItemContent,
    TreeItemContainer: styled.div`
        display: flex;
        flex-direction: row;
        gap: ${spacing(1)};
        align-items: center;
        padding: ${spacing(0.5)} 0;
        padding-left: calc((var(--tree-item-level) - 1) * ${spacing(4)});

        &[data-hidden] {
            display: none;
        }
    `,
    Checkbox: styled(Checkbox)``,
    ExpandButton: styled(Button)`
        background-color: transparent;
        border: none;
        outline: none;
        padding: 0;
        cursor: pointer;

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
    `,
}

export default Styled
